import queryString from "query-string";

import { useIsClientSide } from "./isClient.hook";

const useTrackingID = () => {
    const isClient = useIsClientSide();

    if (!isClient) {
        return "";
    }

    const { pp_tracking_id } = queryString.parse(location.search);
    return pp_tracking_id ? `?pp_tracking_id=${pp_tracking_id}` : "";
};

export { useTrackingID };
